<template>
  <div class="ma-0 pa-0">
    <pdf v-bind="$attrs" v-if="!inDialog" />
    <div v-else>
      <v-row>
        <v-col sm="6" cols="12">
          <v-btn
            color="primary"
            class="text-none"
            outlined
            @click="dialog = true"
          >
            <v-icon class="mr-2" small>mdi-eye</v-icon>
            {{ $_t('View Appointment Letter') }}
          </v-btn>
        </v-col>
        <v-col cols="12" sm="6">
          <v-btn
            color="primary"
            class="text-none"
            outlined
            @click="downloadPdf()"
          >
            <v-icon class="mr-2" small>mdi-download</v-icon>
            {{ $_t('Download Appointment Letter') }}
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <v-dialog
      v-if="dialog"
      v-model="dialog"
      transition="dialog-bottom-transition"
      :width="dialogWidth"
      scrollable
    >
      <v-card width="100%" max-height="95vh" color="#fff">
        <div style="width: 100%; overflow-y: scroll;">
          <pdf v-for="i in pagesNum" :key="i" :src="pdfUrl" :page="i"></pdf>
        </div>
        <v-divider />
        <v-card-actions>
          <v-btn color="primary" text @click="downloadPdf()">
            {{ $_t('Download') }}
            <v-icon class="ml-1" small>mdi-download</v-icon>
          </v-btn>
          <v-spacer />
          <v-btn color="primary" text @click="dialog = false">
            {{ $_t('Close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import pdf from 'vue-pdf';

import {
  defineComponent,
  computed,
  onMounted,
  ref
} from '@vue/composition-api';

export default defineComponent({
  name: 'PdfViewer',
  components: { pdf },

  props: {
    inDialog: {
      type: Boolean,
      default: false
    },
    src: {
      type: String,
      default: null
    }
  },

  setup(props, ctx) {
    const dialog = ref(false);
    const pdfFile = ref(null);
    const pagesNum = ref(0);
    const pdfUrl = ref(null);
    const downloadLink = ref(null);

    const downloadPdf = () => {
      if (downloadLink.value) {
        downloadLink.value.click();
        return;
      }
      downloadLink.value = document.createElement('a');
      downloadLink.value.href = props.src;
      downloadLink.value.download = `document-pdf-${Date.now()}.pdf`;
      downloadLink.value.click();
    };

    const initPdf = url => {
      pdfFile.value = pdf.createLoadingTask(url);
      pdfFile.value.promise.then(pdf => {
        pagesNum.value = pdf.numPages;
        pdfUrl.value = url;
      });
    };

    const dialogWidth = computed(() => {
      if (ctx.root.$vuetify.breakpoint.smAndDown) {
        return '97vw';
      } else if (ctx.root.$vuetify.breakpoint.mdOnly) {
        return '85vw';
      } else {
        return '70vw';
      }
    });
    onMounted(() => {
      initPdf(props.src);
    });

    return {
      downloadPdf,
      dialogWidth,
      dialog,
      pagesNum,
      pdfUrl
    };
  }
});
</script>
